import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../common/Button';
import ModalWindow from '../../common/Modal';
import styles from './ShopifyAccountModal.module.scss';
import SimpleInput from '../../common/SimpleInput';

function AccountIdModal({ open, onClose, onSave, retailerName, formatName }) {
  const [customerName, setCustomerName] = useState('');
  const formattedRetailerName = useMemo(() => {
    return formatName(retailerName);
  }, [retailerName, formatName]);

  useEffect(() => {
    setCustomerName(formattedRetailerName || '');
  }, [formattedRetailerName]);

  const closeModal = () => {
    onClose(false);
  };

  const onSaveModal = () => {
    onSave(customerName);
  };

  return (
    <ModalWindow open={open} onClose={closeModal} showCloseIcon={true} center>
      <h2>Add Customer Name</h2>
      <hr />
      <div className={styles.body}>
        <SimpleInput
          type="text"
          name="customerName"
          value={customerName}
          onChange={({ target }) => setCustomerName(target.value)}
        />
      </div>
      <hr />
      <div className={styles.footer}>
        <div className={styles.buttons}>
          <Button text="SAVE" onClick={onSaveModal} disabled={!customerName.length} />
        </div>
      </div>
    </ModalWindow>
  );
}

export default AccountIdModal;

AccountIdModal.defaultProps = {
  open: false,
};

AccountIdModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  retailerName: PropTypes.string,
};
